<template>
  <div class="search-result-grid" v-if="searchResultVariants && searchResultVariants.length">
    <template
      v-for="{
        image,
        productName,
        variantName,
        originalQuantity,
        isFavorite,
        productId,
        variantId,
        trackInventory,
        inStock,
        inventoryQuantity,
        increment,
        minimum,
        price,
        deleted,
      } in searchResultVariants"
    >
      <reorder-variant-tile
        :image="image"
        :product-name="productName"
        :product-id="productId"
        :variant-id="variantId"
        :is-favorite="isFavorite"
        :variant-name="variantName"
        :original-quantity="originalQuantity"
        :track-inventory="trackInventory"
        :in-stock="inStock"
        :inventory-quantity="inventoryQuantity"
        :increment="increment"
        :minimum="minimum"
        :price="price"
        :deleted="deleted"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";

.search-result-grid {
  display: grid;
  width: 100%;
  grid-row-gap: 24px;
  grid-column-gap: 24px !important;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 24px;
  padding-block: 24px;

  @include respond-to("medium") {
    grid-template-columns: 1fr 1fr;
  }

  @include respond-to("small") {
    grid-template-columns: 1fr;
    grid-column-gap: 16px !important;
  }
}
</style>

<script>
import { reorderPageHelper } from "./reorderPageHelper";
import ReorderVariantTile from "./reorderVariantTile";

export default {
  mixins: [reorderPageHelper],
  props: {
    searchResult: {
      type: Array,
      default: [],
    },
  },
  components: { ReorderVariantTile },
  computed: {
    searchResultVariants() {
      return this.searchResult?.reduce((accumulator, reorder) => {
        return [...accumulator, ...this.mapReorderToVariantList(reorder)];
      }, []);
    },
  },
};
</script>
